import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID, signal } from "@angular/core";
import moment from "moment";
import { BehaviorSubject, firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SesionService {
  nameCity: string = "c171";
  nameAirport: string = "c172";
  comunas: string ="h4312";
  nameLatest: string = "latest";
  searchTransfer: string = "transferSearch";
  nameLastDate: any = "4pd4t3c1t135";
  nameLastDateProgress: any = "4pd4t3c1t135p40g4355";
  latestObj: any;
  latestObjTransfer: any;
  searches: any[] = [];
  searchesTransfer: any[] = [];
  nameLast: string = "l45t";
  lastWanted: any = [];
  nameVar: string = "ch1l3p4s4g3sUs3435-chilepasajes";
  user: any = undefined
  userSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined)
  lastServices: any = "l4stS3rvic3s";
  backToServices: any = "b4ckchil3p4s4j3s";
  lang: string = "es";
  cancelationsPublic: any = "c4ncelat10nsIpPubl1c";
  stopIda: any = "ch1l3p4s4g3sUs3435IdaStops";
  stopReg: any = "ch1l3p4s4g3sUs3435RegStops";
  url: string = "ch1l3p4s4g3sUs3435URLS34rch";
  urlTransfer: string = "ch1l3p4s4g3sUs3435URLS34rchTr4nsf3r";
  complement: string = "ch1l3p4s4g3sUs3435C0mpl3m3nt0";
  language: string = "ch1l3p4s4g3sUs3435L4ngu45";
  serviceTransfer: string = "ch1l3p4s4g3sUsT44nf34";
  serviceTransferBack: string = "ch1l3p4s4g3sUsT44nf34Kmdjf23";
  viewFilterMobile: any = false;
  modalRefParent: any;
  lastSelectedOrigin: string = "fdsasfsda3sfasd";
  lastSelectedOriginDesktop: string = "DdsEsfsSa3TfOP";
  lastSelectedDestination: string = "DdsEsfsSa3TfOPD";
  platformId = inject(PLATFORM_ID)
  constructor() { 
    if(isPlatformBrowser(this.platformId)) {
      this.getUser()
    }
  }
  generateUrl(url) {
    return `/${this.lang}/${url}`;
  }

  setComplement(complement: any) {
    return localStorage.setItem(this.complement, complement);
  }

  getComplement() {
    let data = localStorage.getItem(this.complement);
    if (data) {
      return data;
    }
    return null;
  }

  setLanguage(value) {
    return localStorage.setItem(this.language, value);
  }

  getLanguage() {
    let data = localStorage.getItem(this.language);
    if (data) {
      return data;
    }
    return "es";
  }

  setCancelations(data: any) {
    return localStorage.setItem(this.cancelationsPublic, data);
  }

  setUrlSearch(url: any) {
    return localStorage.setItem(this.url, url);
  }

  getUrlSearch() {
    let data = localStorage.getItem(this.url);
    if (data) {
      return data;
    }
    return null;
  }

  setUrlSearchTransfer(url) {
    return localStorage.setItem(this.urlTransfer, url);
  }

  getUrlSearchTransfer() {
    if (typeof localStorage !== 'undefined') {
      let data = localStorage.getItem(this.urlTransfer);
      if (data) {
        return data;
      }
    }
    return null;
  }

  setStopIda(stop: any) {
    return localStorage.setItem(this.stopIda, stop);
  }

  setStopReg(stop: any) {
    return localStorage.setItem(this.stopReg, stop);
  }

  getStopIda() {
    let data = localStorage.getItem(this.stopIda);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  }

  getStopReg() {
    let data = localStorage.getItem(this.stopReg);
    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  addLastServices(last: any) {
    last["date"] = moment().format("YYYY-MM-DD");
    return localStorage.setItem(this.lastServices, JSON.stringify(last));
  }

  addBackStatus(value) {
    localStorage.setItem(this.backToServices, value);
  }

  getBackServices() {
    return localStorage.getItem(this.backToServices);
  }

  getLastServices() {
    let last = localStorage.getItem(this.lastServices);
    if (last) {
      return JSON.parse(last);
    }
    return last;
  }

  resetBack() {
    if(typeof localStorage !== 'undefined'){
      localStorage.removeItem(this.lastServices);
      localStorage.removeItem(this.backToServices);
    }
  }

  /**
  * Almacena las ciudades con es complemento
  * y guarda la fecha de ese dia
  * @param array 
  * @param complemento 
  * @returns 
  */
  loadCities(array: any, complemento) {
    localStorage.setItem(`${complemento}-${this.nameLastDate}`, moment().format("YYYY-MM-DD"));
    let key = `${complemento}-${this.nameCity}`;
    return localStorage.setItem(key, JSON.stringify(array));
  }

  /**
  * Revisa si es necesario actualizar las ciudades
  */
  checkoutResetCities(complemento: string): boolean {
    let hayCiudades = (typeof localStorage !== 'undefined') ? localStorage.getItem(`${complemento}-${this.nameCity}`) : "";
    let ultimaFecha = (typeof localStorage !== 'undefined') ? localStorage.getItem(`${complemento}-${this.nameLastDate}`) : "";

    if (!hayCiudades) {
      return true;
    }

    if (!ultimaFecha) {
      return true;
    } else {
      let now = moment();
      let old = moment(ultimaFecha);
      let diff = now.diff(old, "days");

      if (diff >= 1) {
        // localStorage.removeItem(`${complemento}-${this.nameCity}`);
        return true;
      } else {
        return false;
      }
    }
  }

  /**
   * Eliminamos las ciudades almacenadas y la fecha
   * @param complemento 
   */
  deleteCitiesSaved (complemento): void {
    if(typeof localStorage !== 'undefined'){
      localStorage.removeItem(`${complemento}-${this.nameCity}`);
      localStorage.removeItem(`${complemento}-${this.nameLastDate}`);
    }
  }

  newObjectSesion() {
    return {
      id: undefined,
      email: undefined,
      firstname: undefined,
      lastname: undefined,
      phone: undefined,
      rut: undefined,
      passcode: undefined,
      picture: undefined,
      country: undefined,
      passengers: [],
    };
  }

  getUser() {
    let user = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.nameVar) : "";
    if (user && user != undefined) {
      this.user = JSON.parse(user);
      this.userSubject.next(this.user)
      return this.user;
    }
    return
  }

  newUser(obj, picture) {
    let user = undefined
    user = this.newObjectSesion();
    user.id = obj.id || undefined;
    user.firstname = obj.firstname || "";
    user.lastname = obj.lastname || "";
    user.email = obj.email || "";
    user.phone = obj.phone || "";
    user.rut = obj.rut || "";
    user.picture = picture || "";
    user.passcode = obj.passcode || undefined;
    user.country = obj.country || undefined;
    this.user = user
    this.userSubject.next(user)
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.nameVar, JSON.stringify(this.user)) : false;
  }

  updateUser(user) {
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.nameVar, user) : false;
  }

  deleteUser() {
    this.user = undefined;
    this.userSubject.next(undefined)
    
    // delete the last session
    if(typeof localStorage !== 'undefined'){
      localStorage.removeItem("XpQr9Tf42mLn7W");
    }

    return (typeof localStorage !== 'undefined') ? localStorage.removeItem(this.nameVar) : false;
  }

  async getUserSubject() {
    return await firstValueFrom(this.userSubject.asObservable())
  }
  checkoutResetProgress(force = false) {
    let val = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.nameLastDateProgress) : false;

    if (val) {
      let now = moment();
      let old = moment(val);
      let diff = now.diff(old, "minutes");
      if (diff > 10 || force) {
        if(typeof localStorage !== 'undefined'){
          localStorage.setItem(this.nameLastDateProgress, now.format());
        }
      }
      return diff;
    }
    return 0;
  }

  addCity(complement, name) {
    let key = `${complement}-${this.nameLast}`;
    let data: any = (typeof localStorage !== 'undefined') ? localStorage.getItem(key) : false;
    if (data) {
      data = data.split(",");
      this.lastWanted = data.filter((item) => item !== name);
      this.lastWanted.unshift(name);
      this.lastWanted = this.lastWanted.slice(0, 4);
      return (typeof localStorage !== 'undefined') ? localStorage.setItem(key, this.lastWanted) : false;
    } else {
      return (typeof localStorage !== 'undefined') ? localStorage.setItem(key, name) : false;
    }
  }

  getLastWanted(complement) {
    let key = `${complement}-${this.nameLast}`;
    let last = (typeof localStorage !== 'undefined') ? localStorage.getItem(key) : "";

    if (last) {
      return last.split(",");
    }
    return last;
  }

  /**
  * Obtiene las ciudades almacenadas anteriormente
  * @param complemento 
  * @returns 
  */
  getCities(complemento) {
    let key = `${complemento}-${this.nameCity}`;
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(key) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  /**
   * Guarda las tres ultimas busquedas del usuario
   * @param obj: origin - destination - dateStart
   * @returns 
   */
  saveSearch(obj) {
    this.latestObj = obj;
    let mismaBusqueda = false;
    
    const searchesLast = this.getSearch();
    if(searchesLast && searchesLast.length > 0){
      searchesLast.forEach(element =>{
        if (
          element.origin[0] === this.latestObj.origin[0] &&
          element.destination[0] === this.latestObj.destination[0] &&
          element.fechaIda.year === this.latestObj.fechaIda.year &&
          element.fechaIda.month === this.latestObj.fechaIda.month &&
          element.fechaIda.day === this.latestObj.fechaIda.day
        ) {
          // la busqueda ya existe dentro del array
          mismaBusqueda = true
        }
      });
    }
    
    if(!mismaBusqueda){
      if (this.searches.length > 2) {
        //saca el primer objeto
        this.searches.shift();
        // inserta el objeto nuevo
        this.searches.push(this.latestObj);
      } else {
        // inserta el objeto nuevo
        this.searches.push(this.latestObj);
      }
    } else {
      this.searches = searchesLast;
    }

    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.nameLatest, JSON.stringify(this.searches)) : false;
  }

  getSearch() {
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.nameLatest) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  saveComunasSeleccionadas(obj) {
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.comunas, JSON.stringify(obj)) : false;
  }
  
  getComunasSeleccionadas() {
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.comunas) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  saveSearchTransfer(obj) {
    this.latestObjTransfer = obj;
    let mismaBusqueda = false;
    
    const searchesLast = this.getSearchTransfer();
    if(searchesLast && searchesLast.length > 0){
      searchesLast.forEach(element =>{
        if (
          element.origin === this.latestObjTransfer.origin &&
          element.destination === this.latestObjTransfer.destination &&
          element.dateStart.year === this.latestObjTransfer.dateStart.year &&
          element.dateStart.month === this.latestObjTransfer.dateStart.month &&
          element.dateStart.day === this.latestObjTransfer.dateStart.day &&
          element.time.hour === this.latestObjTransfer.time.hour &&
          element.time.minute === this.latestObjTransfer.time.minute 
        ) {
          // la busqueda ya existe dentro del array
          mismaBusqueda = true
        }
      });
    }
    
    if(!mismaBusqueda){
      if (this.searchesTransfer.length > 2) {
        //saca el primer objeto
        this.searchesTransfer.shift();
        // inserta el objeto nuevo
        this.searchesTransfer.push(this.latestObjTransfer);
      } else {
        // inserta el objeto nuevo
        this.searchesTransfer.push(this.latestObjTransfer);
      }
    }else {
      this.searchesTransfer = searchesLast;
    } 
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.searchTransfer, JSON.stringify(this.searchesTransfer)) : false;
  }

  getSearchTransfer() {
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.searchTransfer) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  loadAirport(array: any, complemento) {
    let key = `${complemento}-${this.nameAirport}`;
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(key, JSON.stringify(array)) : false;
  }

  getAirport(complemento) {
    let key = `${complemento}-${this.nameAirport}`;
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(key) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  saveServiceTransfer(obj) {
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.serviceTransfer, JSON.stringify(obj)) : false;
  }

  saveBackServiceTransfer(obj) {
    return (typeof localStorage !== 'undefined') ? localStorage.setItem(this.serviceTransferBack, JSON.stringify(obj)) : false;
  }

  getServiceTransfer() {
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.serviceTransfer) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  deleteServicesTransfers() {
	if(typeof localStorage !== 'undefined'){
	    localStorage.removeItem(this.serviceTransfer);
	    localStorage.removeItem(this.serviceTransferBack);
	}
  }

  getBackServiceTransfer() {
    let data = (typeof localStorage !== 'undefined') ? localStorage.getItem(this.serviceTransferBack) : false;
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }

  saveNewProgress() {
    let date = moment().format();
    (typeof localStorage !== 'undefined') ? localStorage.setItem(this.nameLastDateProgress, date) : false;
  }

  /**
   * Obtiene el origen seleccionado segun el complemento
   * @param complement 
   * @returns 
   */
  getOriginSelected(complement): any {
    return (typeof localStorage !== 'undefined') ? localStorage.getItem(`${complement}-${this.lastSelectedOrigin}`) : false;
  }

  /**
   * Almacena el objeto asociado al origen seleccionado
   * @param obj 
 */
  saveOriginSelected(complement, obj): void {
    if(typeof localStorage !== 'undefined'){
      let key = `${complement}-${this.lastSelectedOrigin}`
      localStorage.setItem(key, JSON.stringify(obj));
    }
  }

  /**
   * Almacena el objeto asociado al destino seleccionado
   * @param obj 
  */
   saveDestinationSelected(complement, obj): void {
    if(typeof localStorage !== 'undefined'){
      let key = `${complement}-${this.lastSelectedDestination}`
      localStorage.setItem(key, JSON.stringify(obj));
    }
  }

   /**
   * Elimina el objeto asociado al destino seleccionado
   * @param obj 
  */
   deleteDestinationSelected(complement): void {
    if(typeof localStorage !== 'undefined'){
      let key = `${complement}-${this.lastSelectedDestination}`
      localStorage.removeItem(key);
    }
  }

  /**
   * Obtiene el destino seleccionado
   * @param complement 
   * @returns 
   */
  getDestinationSelected(complement): any {
    return (typeof localStorage !== 'undefined') ? localStorage.getItem(`${complement}-${this.lastSelectedDestination}`) : false;
  }

  /**
   * Almacena los destinos del origen seleccionado desde el pipe
   * @param complement 
   * @param destinationCities 
   */
  saveDestinationCitiesPipe(complement, destinationCities):void {
    if(typeof localStorage !== 'undefined'){
      let key = `${complement}-${this.lastSelectedOriginDesktop}`
      localStorage.setItem(key, JSON.stringify(destinationCities));
    }
  }

  /**
   * Obtiene los destinos del origen seleccionado desde el pipe
   * @param complement 
   * @returns 
   */
  getDestinationCitiesPipe(complement): any {
    return (typeof localStorage !== 'undefined') ? localStorage.getItem(`${complement}-${this.lastSelectedOriginDesktop}`) : false;
  }

  /**
   * Elimina los destinos del origen seleccionado desde el pipe
   * @param complement 
   * @returns 
   */
  deleteDestinationCitiesPipe(complement): any {
    return (typeof localStorage !== 'undefined') ? localStorage.removeItem(`${complement}-${this.lastSelectedOriginDesktop}`) : false
  }

  /**
   * Almacena el token en el localStorage
   * @param token 
   * @returns 
   */
  setAccessToken(token: string) {
    return (typeof localStorage !== 'undefined') ? localStorage.setItem('token', token) : null;
  }

  /**
   * Obtiene el token del localStorage
   * @returns 
   */
  getAccessToken() {
    return (typeof localStorage !== 'undefined') ? localStorage.getItem('token') : null;
  }

  /**
   * Elimina el token del localStorage
   * @returns 
   */
  deleteAccessToken() {
    return (typeof localStorage !== 'undefined') ? localStorage.removeItem('token') : null;
  }
}
